import { Component, OnInit, Input } from '@angular/core';
import { SerialSearchExpression } from 'src/app/shared/search-expression/serial-search-expression.model';
import { DatePeriodEnum } from 'src/app/shared/search-expression/date-period.enum';

@Component({
  selector: 'wl-expression-summary',
  templateUrl: './expression-summary.component.html',
  styleUrls: ['./expression-summary.component.less'],
    standalone: false
})
export class ExpressionSummaryComponent implements OnInit {
  @Input() public searchExpression: SerialSearchExpression;
  @Input() public hideBinaryOperator = false;
  public datePeriodEnum: any = DatePeriodEnum;

  constructor() {}

  ngOnInit(): void {}
}
